












import {Component, Prop, Vue} from 'vue-property-decorator';
import JdhInputArea from "@/design-system/forms/shared/JdhInputArea.vue"
import JdhInlineInputArea from "@/design-system/forms/fields/JdhInlineInputArea.vue"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({
    components: {JdhInlineInputArea, JdhInputArea}
})
export default class JdsInlineTextField extends Vue {
    @Prop() label!: string
    @Prop() value!: string
    focus = false

    emitInput(value: string) {
        this.$emit('input', value)
    }
}
